<template>
  <multiselect
    v-model="computedValue"
    :multiple="true"
    :limit-text="limitText"
    :options-limit="300"
    :options="this.options"
    @search-change="onSearchChange"
    :show-labels="false"
    :loading="isLoading"
    :option-height="49"
    :close-on-select="true"
    v-bind="$attrs"
    @open="onOpen"
    track-by="title"
    label="title"
    :custom-label="customLabel"
    :internal-search="false"
    class='custom-multiselect--min-width'
    :max-height="49*6 + 48 + 59"
  >
    <li class='pt-24 px-16 mb-8 t-small-uppercase fw-500 o-02' slot='beforeList' v-if="!query">
      {{localization.topCities}}
    </li>
    <template slot='noResult'>
      {{localization.noResult}}
    </template>
    <template slot='noOptions'>
      {{localization.listIsEmpty}}
    </template>
    <template slot='option' slot-scope='{ option }'>
      <div class='grid-x align-justify t-label-regular'>
        <p class='shrink cell' v-text='option.title'></p>
        <p class='shrink cell t-small o-04' v-text='option.comment' v-if='option.comment'></p>
      </div>
    </template>
  </multiselect>
</template>
<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { matchSorter } from 'match-sorter'
import memoize from 'lodash/memoize'

export default {
  components: { Multiselect },
  name: 'LocationsPicker',
  data() {
    return {
      options: [],
      topCities: [],
      isLoading: false,
      query: '',
      localization: window.localization || {},
      selectionObjects: this.getSelectionObjects(),
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.selectionObjects
      },
      set(selection) {
        this.selectionObjects = selection
        this.$emit('input', Array.isArray(selection) ? selection.map(el => el.title) : selection)
      }
    }
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
    },
    onOpen: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    limitText(count) {
      return `+${count}`
    },
    fetchLocations: memoize(async function() {
      const res = await fetch(this.url)
      const json = await res.json()
      return json
    }),
    async onSearchChange(query) {
      this.query = query

      if (!query) {
        this.options = this.topCities
        return
      }

      this.isLoading = true
      const matches = matchSorter(await this.fetchLocations(), query, {
        keys: [
          'title',
          'comment',
          'correspondance',
        ],
        // threshold: matchSorter.rankings.WORD_STARTS_WITH,
      }).slice(0, 6)
      this.options = this.uniqifyOptions(matches)
      this.isLoading = false
    },
    customLabel(option) {
      return option.title
    },
    getSelectionObjects() {
      return Array.isArray(this.value) ? this.value.map(title => ({ title })) : this.value
    },
    uniqifyOptions(options) {
      return options.map(option => ({ ...option, id: `${option.title},${option.comment}` }))
    }
  },

  mounted() {

    // hack - move input inside of dropdown to make more space
    const input = this.$el.querySelector('.multiselect__input')
    const contentWrapper = this.$el.querySelector('.multiselect__content-wrapper')
    contentWrapper.insertBefore(input, contentWrapper.children[0])
    input.setAttribute('placeholder', window.localization.enterLocation)

    fetch(`${this.url}?top=1`)
      .then(res => res.json())
      .then(json => {
        this.topCities = this.uniqifyOptions(json)
        this.options = this.topCities
      })
  },
  watch: {
    value() {
      this.selectionObjects = this.getSelectionObjects()
    }
  }
}
</script>